import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'

import Layout from '../components/Layout'
import FeaturedProperties from '../components/FeaturedProperties'

export const IndexPageTemplate = ({
  image,
  heading,
  subheading,
}) => (
  <div>
    <div
      className="full-width-image-container mt-0"
      style={{
        backgroundImage: `url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`,
        backgroundPosition: `bottom center`,
        //backgroundAttachment: `fixed`,
      }}
    >
      <div className="full-width-image-container-content container"
        style={{
          display: 'flex',
          height: '250px',
          lineHeight: '1',
          justifyContent: 'space-around',
          alignItems: 'left',
          flexDirection: 'column',
          textAlign: 'left',
          width: '100%',
        }}
      >
        <h1
          className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen"
          style={{
            color: 'white',
            lineHeight: '1',
          }}
        >
          {heading}
        </h1>
        <p
          className="has-text-weight-bold is-size-6-mobile is-size-5-tablet is-size-5-widescreen"
          style={{
            color: 'white',
            lineHeight: '1',
          }}
        >
          {subheading}
        </p>
        <Link
          to="/property"
          className="button has-text-weight-bold is-size-6 mt-6"
          style={{
            color: 'white',
            borderColor: 'white',
            maxWidth: '200px',
          }}>
           Property
        </Link>
      </div>
    </div>
    <section>
      <div className="section">
        <div className="container pt-4 pb-5">
          <FeaturedProperties />
          <div className="columns">
            <div className="column is-12">
              <div className="column is-12 has-text-centered">
                <Link className="button has-text-weight-bold mt-6 mb-3 is-size-5-desktop" to="/property">
                  ดูอสังหาฯ ทั้งหมด
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
)

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  heading: PropTypes.string,
  subheading: PropTypes.string,
}

const Index = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        heading={frontmatter.heading}
        subheading={frontmatter.subheading}
      />
    </Layout>
  )
}

Index.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default Index

export const pageQuery = graphql`
  query IndexPage {
    markdownRemark(frontmatter: { templateKey: { eq: "index" }}) {
      frontmatter {
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        heading
        subheading
      }
    }
  }
`
